import { Helmet } from 'react-helmet-async';

export const NotScalableViewportHelmet = () => {
  return (
    <Helmet
      meta={[
        {
          name: 'viewport',
          content:
            'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
        },
      ]}
    />
  );
};
